import { TextAreaAutoSize } from "@/Common/Components/Inputs/TextAreaAutoSize";

import styles from "./CareElementTextAreaField.module.scss";

interface CareElementTextAreaFieldProps {
    id: string;
    dataCy?: string;
    value?: string;
    isEditable: boolean;
    onTextChange: (value: string) => void;
}

function CareElementTextAreaField({ id, dataCy, isEditable, value = "", onTextChange }: Readonly<CareElementTextAreaFieldProps>): JSX.Element {
    const careElementNotesId = `careElementNotes-${id}`;

    return (
        <div className={styles.textFieldContainer}>
            {isEditable
                ? (
                    <TextAreaAutoSize
                        dataCy={dataCy}
                        id={careElementNotesId}
                        value={value}
                        onTextChangeCallback={onTextChange}
                        minHeight="80px"
                        maxHeight="200px"
                        cssClass={styles.textFieldArea}
                        disabled={!isEditable}
                        maxLength={500}
                    />
                )
                : <p>{value}</p>
            }
        </div>
    );
}

export default CareElementTextAreaField;
